import { atom } from "jotai";

export interface CopilotDrawerState {
  setIsCopilotOpen: (value: boolean) => void;
}

/**
 * Atom that provides copilot drawer state control functions.
 *
 * Usage:
 * ```typescript
 * // In a component - use OUR OWN useCopilotDrawerState hook directly that checks if copilot is enabled - NOT the one from ai-toolkit/client
 * import { useCopilotDrawerState } from "../../hooks/useCopilotDrawerState";
 * const [isCopilotOpen, setIsCopilotOpen] = useCopilotDrawerState();
 * setIsCopilotOpen(false);
 *
 * // In an atom setter - control copilot state
 * const { setIsCopilotOpen } = get(copilotDrawerStateAtom);
 * setIsCopilotOpen(false);
 * ```
 *
 * This atom is hydrated with the actual setter function from useCopilotDrawerState
 * in CanvasHydrator to enable copilot control from anywhere in the atom system.
 * Use OUR OWN useCopilotDrawerState hook in components (NOT the one from ai-toolkit/client),
 * use this atom in atom setters.
 */
export const copilotDrawerStateAtom = atom<CopilotDrawerState>({
  setIsCopilotOpen: () => {},
});

copilotDrawerStateAtom.debugLabel = "copilotDrawerStateAtom";
